import { render } from "./Actualite.vue?vue&type=template&id=646a96f4&scoped=true"
import script from "./Actualite.vue?vue&type=script&lang=js"
export * from "./Actualite.vue?vue&type=script&lang=js"

import "./Actualite.vue?vue&type=style&index=0&id=646a96f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646a96f4"]])

export default __exports__